export default function (props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none" {...props}>
            <path
                d="M15.1002 6.70362H48.8998C50.191 6.70362 51.2964 7.81374 51.2964 9.25722V54.7428C51.2964 56.1863 50.191 57.2964 48.8998 57.2964H15.1002C13.809 57.2964 12.7036 56.1863 12.7036 54.7428V9.25722C12.7036 7.81374 13.809 6.70362 15.1002 6.70362Z"
                stroke="black"
                strokeWidth="1.40725"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                d="M22.0405 11.8314C22.0343 12.2425 21.9053 12.6434 21.669 12.9837C21.4323 13.3244 21.0983 13.5894 20.7079 13.7444C20.3174 13.8994 19.8889 13.9369 19.4766 13.852C19.0642 13.767 18.6876 13.5637 18.3935 13.2688C18.0996 12.9739 17.9012 12.6007 17.8222 12.1964C17.7431 11.7922 17.7867 11.3738 17.9476 10.9935C18.1086 10.6131 18.3803 10.2869 18.7297 10.057C19.079 9.82706 19.4901 9.70383 19.9112 9.70362C20.1942 9.70439 20.474 9.76056 20.7345 9.86869C20.9953 9.97691 21.2312 10.1349 21.4289 10.3333C21.6266 10.5316 21.7821 10.7662 21.887 11.0234C21.9917 11.2803 22.0438 11.5549 22.0405 11.8314Z"
                stroke="black"
                strokeWidth="1.40725"
                strokeMiterlimit="10"
            />
            <path d="M30.5825 10.6225H29.5514V11.7058H30.5825V10.6225Z" stroke="black" strokeWidth="1.40725" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M35.481 10.6225H34.4499V11.7058H35.481V10.6225Z" stroke="black" strokeWidth="1.40725" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M40.3764 10.6225H39.3453V11.7058H40.3764V10.6225Z" stroke="black" strokeWidth="1.40725" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M21.1313 43.9982C19.698 41.8527 18.9329 39.3303 18.9329 36.75C18.9329 33.2899 20.3073 29.9714 22.7536 27.5248C25.1999 25.0781 28.5178 23.7036 31.9774 23.7036C34.5573 23.7036 37.0793 24.4688 39.2244 25.9023C41.3696 27.3359 43.0415 29.3734 44.0289 31.7573C45.0162 34.1413 45.2745 36.7645 44.7712 39.2952C44.2678 41.826 43.0255 44.1506 41.2011 45.9752C39.3768 47.7998 37.0526 49.0423 34.5222 49.5457C31.9918 50.0491 29.3691 49.7907 26.9855 48.8033C24.602 47.8159 22.5647 46.1437 21.1313 43.9982Z"
                stroke="black"
                strokeWidth="1.40725"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                d="M42.7664 36.7703C42.7664 38.9012 42.1345 40.9841 40.9506 42.7556C39.7667 44.5272 38.084 45.9076 36.1154 46.7225C34.1469 47.5373 31.9809 47.7498 29.8916 47.3332C27.8023 46.9166 25.8834 45.8895 24.3778 44.3819C22.8722 42.8743 21.8476 40.9539 21.4335 38.8637C21.0194 36.7735 21.2345 34.6075 22.0516 32.6396C22.8687 30.6717 24.251 28.9904 26.0237 27.8085C27.7964 26.6266 29.8797 25.997 32.0102 25.9996C34.8641 26.003 37.5999 27.1393 39.6167 29.1588C41.6336 31.1783 42.7664 33.916 42.7664 36.7703Z"
                stroke="black"
                strokeWidth="1.40725"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                d="M21.5 39C21.5 39 25.6947 32.7556 31.8745 38.9362C38.0542 45.1168 42.5 37.5 42.5 37.5"
                stroke="black"
                strokeWidth="1.40725"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path d="M11.9999 16.5229H51.9999" stroke="black" strokeWidth="1.40725" strokeMiterlimit="10" />
        </svg>
    );
}
